/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate how much water to drink per day from weight and activity.`)
};

const es_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima cuánta agua beber al día según el peso y la actividad.`)
};

const de_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze deinen täglichen Wasserbedarf anhand von Gewicht und Aktivität.`)
};

const nl_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat hoeveel water je per dag moet drinken op basis van gewicht en activiteit.`)
};

const fr_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez la quantité d'eau à boire par jour selon le poids et l'activité.`)
};

const it_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima quanta acqua bere al giorno in base a peso e attività.`)
};

const pt_br2_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime quanta água beber por dia com base no peso e na atividade física.`)
};

const pt_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime quanta água beber por dia com base no peso e na atividade.`)
};

const ja_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重と活動量から1日に飲むべき水分量を推定します。`)
};

const zh_water_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据体重和活动量估算每日建议饮水量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_tool_description", locale)
	if (locale === "en") return en_water_tool_description(inputs)
	if (locale === "es") return es_water_tool_description(inputs)
	if (locale === "de") return de_water_tool_description(inputs)
	if (locale === "nl") return nl_water_tool_description(inputs)
	if (locale === "fr") return fr_water_tool_description(inputs)
	if (locale === "it") return it_water_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_water_tool_description(inputs)
	if (locale === "pt") return pt_water_tool_description(inputs)
	if (locale === "ja") return ja_water_tool_description(inputs)
	return zh_water_tool_description(inputs)
};